/**
 *  ・クラス名
 *    マスタ取得モデル
 *  ・概要
 *    マスタを取得する関連処理を記述
 *  ・更新履歴
 */
import hexabaseState from '@/store/hexabase';
import { DateTime } from 'luxon';
import BaseModel from '../baseModel';

/* eslint-disable @typescript-eslint/camelcase */
export interface Payload {
  conditions?: {
    id: string;
    search_value: Array<string>;
  }[];
  sort_fields?: [
    {
      id: string;
      order: 'desc' | 'asc';
    }
  ];
  per_page?: number;
  page?: number;
  use_display_id?: boolean;
  return_number_value?: boolean;
}

export default class Tax extends BaseModel {
  // マスターDB名
  private dbName = 'm_tax';

  payload?: Payload;

  constructor(payload?: Payload) {
    super(payload);
    const defaultPayload = {
      conditions: [],
      per_page: 0,
      page: 1,
      use_display_id: true,
      return_number_value: true
    };
    this.payload = payload ? payload : defaultPayload;
  }

  async init() {
    // 検索条件payloadを使用して、APIから値を取得、各モデル値にセットする
    return await this.getItemList(hexabaseState.applicationId, this.dbName, this.payload);
  }

  async getData() {
    return await this.init();
  }

  /**
   * マスタデータをフロント（マスタコントロール）で
   * 使用可能な形に整形して返します
   */
  async getFormatData() {
    return await this.getData().then(data => this.modifyMasterData(data, 'id', this.dbName)).then(data => this.modifyData(data))
  }

  modifyData(data: any) {
    // 対象項目の日付データフォーマット
    for (const key in data.body) {
      data.body[key].application_start_date = data.body[key].application_start_date ? DateTime.fromISO(data.body[key].application_start_date).toFormat('yyyy/MM/dd') : '';
      data.body[key].application_end_date = data.body[key].application_end_date ? DateTime.fromISO(data.body[key].application_end_date).toFormat('yyyy/MM/dd') : '';
    }
    // 有効ステータスのみ抽出
    data.body = data.body.filter((v: { Status: string }) => v.Status === '有効');
    return data;
  }
}
